import { ValueOfKey } from '../../utils-types';

export const SCAN_IQ_CUSTOMER_STATUS = {
  PENDING: 'PENDING',
  CANCELED: 'CANCELED',
  INACTIVE: 'INACTIVE',
  INACTIVE_ONE_TIME: 'INACTIVE_ONE_TIME',
  PAYMENT_ISSUE: 'PAYMENT_ISSUE',
  ACTIVE: 'ACTIVE',
  ACTIVE_ONE_TIME: 'ACTIVE_ONE_TIME',
};

export type ScanIqCustomerStatusType = ValueOfKey<typeof SCAN_IQ_CUSTOMER_STATUS>;
